import { styled } from "@mui/system";
import { Box } from "@mui/material";
import { Form } from "formik";

export const FormContainer = styled(Form)(({ theme }) => ({
  width: "100%",
  "& .MuiGrid-root": {
    "&> .MuiGrid-item": {
      paddingTop: "24px"
    }
  }
}));

export const FlexContainer = styled(Box)(({ theme }) => ({
  marginTop: "0",
  marginBottom: "0"
}));

export const RelativeBox = styled(Box)(({ theme }) => ({
  position: "relative"
}));

export const TabletBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.only("xs")]: {
    marginBottom: "20px"
  }
}));

export const ButtonWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  margin: "40px 0"
}));

export const RemoveButton = styled("div")(({ theme }) => ({
  float: "right",
  position: "inherit",
  marginRight: "20px",
  padding: "5px 10px",
  borderRadius: "20px",
  "& span": {
    textDecoration: "none"
  }
}));

export const AddButton = styled("div")(({ theme }) => ({
  marginRight: "20px",
  padding: "5px 10px",
  borderRadius: "20px",
  "& span": {
    textDecoration: "none"
  }
}));

export const Label = styled("p")(({ theme }) => ({
  marginBottom: 0,
  paddingLeft: 10,
  paddingRight: 10
}));
